import * as React from 'react';

import { Button, Flex, Input, Typography } from 'antd';

import {
  AntdDateRangePicker,
  AntdRouterLink,
  PlusOutlinedIcon,
} from 'components';
import { PATHNAME } from 'utils';

const {
  DEFAULT: { SLUG_SEPARATOR: DEFAULT_SLUG_SEPARATOR },
  LOCAL: {
    PRODUCTS: { CREATE_URL: PRODUCTS_CREATE_URL },
  },
} = PATHNAME;

type ProductsHeaderProps = {
  searchKey: string;
  handleSearchKey: (searchKey: string) => void;
  handleLowerBoundCreateDate: (lowerBoundCreateDate?: string) => void;
  handleUpperBoundCreateDate: (upperBoundCreateDate?: string) => void;
};

const ProductsHeader = ({
  searchKey,
  handleSearchKey,
  handleLowerBoundCreateDate,
  handleUpperBoundCreateDate,
}: ProductsHeaderProps) => (
  <Flex
    gap='middle'
    className='mb-5 max-xl:flex-col xl:items-center xl:justify-between'
  >
    <Typography.Title level={1} className='mb-0 text-nowrap text-lg'>
      محصول‌ها
    </Typography.Title>
    <Flex gap='small' className='max-xl:flex-wrap'>
      <Input.Search
        allowClear
        className='max-xl:basis-full'
        styles={{
          affixWrapper: {
            height: '2.5rem',
          },
        }}
        placeholder='جستجوی محصول‌ها'
        defaultValue={searchKey}
        onSearch={value => handleSearchKey(value)}
      />
      <AntdDateRangePicker
        allowEmpty
        className='max-xl:basis-full'
        onDateChange={([lowerBoundCreateDate, upperBoundCreateDate]) => {
          handleLowerBoundCreateDate(lowerBoundCreateDate);
          handleUpperBoundCreateDate(upperBoundCreateDate);
        }}
      />
      <AntdRouterLink
        to={`${PRODUCTS_CREATE_URL}${DEFAULT_SLUG_SEPARATOR}`}
        className='max-xl:basis-full'
      >
        <Button type='primary' className='w-full' icon={<PlusOutlinedIcon />}>
          افزودن محصول
        </Button>
      </AntdRouterLink>
    </Flex>
  </Flex>
);

export { ProductsHeader };
